import { a as createCommonjsModule, b as getDefaultExportFromCjs } from '../common/_commonjsHelpers-fdecda49.js';
import { i as interopRequireDefault } from '../common/interopRequireDefault-00cfe768.js';
import { c as classnames, j as jsxRuntime } from '../common/jsx-runtime-4342af96.js';
import { r as react } from '../common/index-59f32655.js';
import { T as ThemeProvider_1 } from '../common/ThemeProvider-76df4d0f.js';

var CardBody_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardBody = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-body');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardBody.displayName = 'CardBody';
var _default = exports.default = CardBody;
module.exports = exports.default;
});

var CardFooter_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardFooter = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-footer');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardFooter.displayName = 'CardFooter';
var _default = exports.default = CardFooter;
module.exports = exports.default;
});

var CardHeaderContext = createCommonjsModule(function (module, exports) {
"use client";

exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const context = /*#__PURE__*/React.createContext(null);
context.displayName = 'CardHeaderContext';
var _default = exports.default = context;
module.exports = exports.default;
});

var CardHeader_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var _classnames = interopRequireDefault(classnames);
var _react = _interopRequireWildcard(react);
var React = _react;

var _CardHeaderContext = interopRequireDefault(CardHeaderContext);

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardHeader = /*#__PURE__*/React.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-header');
  const contextValue = (0, _react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0, jsxRuntime.jsx)(_CardHeaderContext.default.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
      ref: ref,
      ...props,
      className: (0, _classnames.default)(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
var _default = exports.default = CardHeader;
module.exports = exports.default;
});

var CardImg_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var _classnames = interopRequireDefault(classnames);
var React = _interopRequireWildcard(react);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardImg = /*#__PURE__*/React.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
var _default = exports.default = CardImg;
module.exports = exports.default;
});

var CardImgOverlay_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardImgOverlay = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'div',
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-img-overlay');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardImgOverlay.displayName = 'CardImgOverlay';
var _default = exports.default = CardImgOverlay;
module.exports = exports.default;
});

var CardLink_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardLink = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'a',
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-link');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardLink.displayName = 'CardLink';
var _default = exports.default = CardLink;
module.exports = exports.default;
});

var divWithClassName = createCommonjsModule(function (module, exports) {


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = className => /*#__PURE__*/React.forwardRef((p, ref) => /*#__PURE__*/(0, jsxRuntime.jsx)("div", {
  ...p,
  ref: ref,
  className: (0, _classnames.default)(p.className, className)
}));
exports.default = _default;
module.exports = exports.default;
});

var CardSubtitle_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);

var _divWithClassName = interopRequireDefault(divWithClassName);

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DivStyledAsH6 = (0, _divWithClassName.default)('h6');
const CardSubtitle = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH6,
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-subtitle');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardSubtitle.displayName = 'CardSubtitle';
var _default = exports.default = CardSubtitle;
module.exports = exports.default;
});

var CardText_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);


function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CardText = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = 'p',
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-text');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardText.displayName = 'CardText';
var _default = exports.default = CardText;
module.exports = exports.default;
});

var CardTitle_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(react);
var _classnames = interopRequireDefault(classnames);

var _divWithClassName = interopRequireDefault(divWithClassName);

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DivStyledAsH5 = (0, _divWithClassName.default)('h5');
const CardTitle = /*#__PURE__*/React.forwardRef(({
  className,
  bsPrefix,
  as: Component = DivStyledAsH5,
  ...props
}, ref) => {
  bsPrefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card-title');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    className: (0, _classnames.default)(className, bsPrefix),
    ...props
  });
});
CardTitle.displayName = 'CardTitle';
var _default = exports.default = CardTitle;
module.exports = exports.default;
});

var Card_1 = createCommonjsModule(function (module, exports) {
"use client";


exports.__esModule = true;
exports.default = void 0;
var _classnames = interopRequireDefault(classnames);
var React = _interopRequireWildcard(react);

var _CardBody = interopRequireDefault(CardBody_1);
var _CardFooter = interopRequireDefault(CardFooter_1);
var _CardHeader = interopRequireDefault(CardHeader_1);
var _CardImg = interopRequireDefault(CardImg_1);
var _CardImgOverlay = interopRequireDefault(CardImgOverlay_1);
var _CardLink = interopRequireDefault(CardLink_1);
var _CardSubtitle = interopRequireDefault(CardSubtitle_1);
var _CardText = interopRequireDefault(CardText_1);
var _CardTitle = interopRequireDefault(CardTitle_1);

function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Card = /*#__PURE__*/React.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body = false,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0, ThemeProvider_1.useBootstrapPrefix)(bsPrefix, 'card');
  return /*#__PURE__*/(0, jsxRuntime.jsx)(Component, {
    ref: ref,
    ...props,
    className: (0, _classnames.default)(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0, jsxRuntime.jsx)(_CardBody.default, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
var _default = exports.default = Object.assign(Card, {
  Img: _CardImg.default,
  Title: _CardTitle.default,
  Subtitle: _CardSubtitle.default,
  Body: _CardBody.default,
  Link: _CardLink.default,
  Text: _CardText.default,
  Header: _CardHeader.default,
  Footer: _CardFooter.default,
  ImgOverlay: _CardImgOverlay.default
});
module.exports = exports.default;
});

var __pika_web_default_export_for_treeshaking__ = /*@__PURE__*/getDefaultExportFromCjs(Card_1);

export default __pika_web_default_export_for_treeshaking__;
